import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { Button, DialogActions, DialogContent, Typography } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { makeStyles } from '@material-ui/core/styles';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import {
  getTotalPrice,
  isConfiguratorStep,
  isCurrentStepOrLater,
  isCurrentStepReady,
  isNextButtonVisible,
  Steps,
} from '../../Reducers/App/Selectors';
import { toNextStep } from '../../Reducers/App/Actions';
import PriceBox from './PriceBox';

const useStyles = makeStyles({
  root: {
    display: 'flex',
  },
  button: {
    width: 400,
    height: 80,
  },
  downloadButton: {
    textTransform: 'none',
    whiteSpace: 'nowrap',
    padding: '4px 15px',
    backgroundColor: grey[900],
    color: 'white',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: grey[700],
    },
  },
  downloadButtonLabel: {
    color: 'white',
  },
});

export const CallToActionBox = (props) => {
  const showNextButton = useSelector(isNextButtonVisible);
  const showConfigurator = useSelector(isConfiguratorStep);
  const disableNextButton = !useSelector(isCurrentStepReady);
  const totalPrice = useSelector(getTotalPrice);
  const isSystemParametersOrLater = useSelector(isCurrentStepOrLater(Steps.SYSTEM_PARAMETERS));
  const showPrice = isSystemParametersOrLater && !!totalPrice && totalPrice !== 0;
  const dispatch = useDispatch();
  const classes = useStyles();
  const onNextClick = () => dispatch(toNextStep());

  const [dialogOpen, setDialogOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [pdfFilename, setPdfFilename] = useState('');

  const downloadPdf = async () => {
    try {
      await Services.interaction.downloadPdfAndCreateBlobURL();
      setPdfUrl(Services.interaction.createPdfUrl());
      setPdfFilename(Services.interaction.getPdfFilename());
      setDialogOpen(true);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className={clsx(classes.root, props.className)}>
      {showPrice && <PriceBox />}
      {showNextButton && (
        <Button className={classes.button} onClick={onNextClick} disabled={disableNextButton}>
          {t('next')}
        </Button>
      )}
      {showConfigurator && (
        <Button className={classes.button} onClick={downloadPdf}>
          {t('downloadPdf')}
        </Button>
      )}
      <CustomDialog
        open={dialogOpen}
        onCancel={() => setDialogOpen(false)}
        dialogTitle={t('pdfDownloadDialog.title')}
      >
        <DialogContent>
          <Typography variant="body1">{t('pdfDownloadDialog.content')}</Typography>
        </DialogContent>
        <DialogActions>
          <MainButton
            component="a"
            href={pdfUrl}
            download={pdfFilename}
            onClick={() => setDialogOpen(false)}
            variant="contained"
            classes={{ root: classes.downloadButton, label: classes.downloadButtonLabel }}
          >
            {t('pdfDownloadDialog.actionButton')}
          </MainButton>
        </DialogActions>
      </CustomDialog>
    </div>
  );
};

CallToActionBox.propTypes = {
  className: PropTypes.string,
};

export default CallToActionBox;
